import React, { useEffect, useState } from "react";
import { Offcanvas, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import moment from "moment";
import errorToast from "../../components/toast/errorToast";
import { availableLanguages } from "../../components/data/language";
import { addResourcePortal, glossaryDropDown } from "../../redux/actions/portalAction";

/**Add Resource Module*/
const AddResource = ({ show, onHide, portalId, reloadData }) => {
  const dispatch = useDispatch();
  const [glossaryList, setGlossaryList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedGlossaries, setSelectedGlossaries] = useState([])
  const [loading, setloading] = useState(false)

  useEffect(() => {
    dispatch(glossaryDropDown({ portal_id: portalId }, onSuccess, onError));
  }, [portalId]);

  const onSuccess = (data) => {
    setloading(false)
    setGlossaryList(data.data.data.glossaries);
  };

  const onError = (data) => {
    errorToast(data.data.message);
    setloading(false)
  };

  const getLangName = (value) => {
    let label = null;
    availableLanguages.forEach((itemdata) => {
      if (itemdata.value === value) {
        label = itemdata.label;
      }
    });
    return label;
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    if (!isChecked) {
      setSelectedGlossaries([]);
      return;
    }
    setSelectedGlossaries(glossaryList.map((ele) => ele.id))
  };

  const handleCheckboxChange = (item) => {
    let updatedList = [...selectedGlossaries];

    if (updatedList.includes(item.id)) {
      updatedList = updatedList.filter(id => id !== item.id);
    } else {
      updatedList.push(item.id);
    }
    setSelectedGlossaries(updatedList);
  };

  const handleAssign = () => {
    const data = {
      id: portalId,
      glossaries: selectedGlossaries
    }
    setloading(true)
    dispatch(addResourcePortal(data, onAssignSuccess, onAssignError))
  };

  const onAssignSuccess = (data) => {
    console.log("resource assigned", data);
    setloading(false)
    onHide()
    reloadData()
  };

  const onAssignError = (data) => {
    setloading(false)
    errorToast(data.data.message);
    console.log("resource assigned error", data);
  };
  console.log("selectedGlossaries", selectedGlossaries);

  return (
    <>
      <Offcanvas backdrop="static" show={show} onHide={onHide} placement="end" style={{ width: "600px" }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Assign resource to portal</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <h5>Glossaries</h5>
            <table className="resource-table fs_12 text-nowrap" style={{ height: "200px", width: "100%" }}>
              <thead>
                <tr>
                  <th width={"2%"} className="border-0 border-bottom">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th width={"12%"} className="border-0 border-bottom">
                    Resource Name
                  </th>
                  <th width={"15%"} className="border-0 border-bottom ">
                    Language Set
                  </th>
                  <th width={"12%"} className="border-0 border-bottom">
                    Last Updated
                  </th>
                  <th className="border-0 border-bottom"></th>
                </tr>
              </thead>
              <tbody>
                {glossaryList.map((item, index) => (
                  <tr key={item.id}>
                    <td width={"2%"} className="border-0 border-bottom">
                      <input
                        type="checkbox"
                        checked={selectedGlossaries.includes(item.id)}
                        onChange={() => handleCheckboxChange(item)}
                      />
                    </td>
                    <td className="border-0 border-bottom">{item?.name}</td>
                    <td className="border-0 border-bottom">
                      {item?.language_set
                        ?.map((item) => `(${getLangName(item)} (${item}))`)
                        .join(", ")}
                    </td>
                    <td className="border-0 border-bottom">
                      {moment(item.updatedAt).format("MM/DD/YY, hh:mm A")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex gap-4 mt-4 px-4">
            <button
              disabled={loading || selectedGlossaries.length < 1}
              type="submit" className="btn btn-primary btn-action d-flex text-nowrap cursor_pointer"
              style={{ minWidth: '80px' }}
              onClick={handleAssign}
            >
              <div className='fs_12 d-flex gap-2 justify-content-center cursor_pointer'>
                {loading ? <Spinner size="sm" className="mt-1" /> : ""}
                <label className="fs_16 cursor_pointer">{!loading ? 'Assign' : 'Assigning'}</label>
              </div>
            </button>
            <button type="button" className="btn btn-primary" onClick={onHide}>
              Cancel
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AddResource;
